import Swiper from "swiper";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";

window.addEventListener('load', () => {
  const listSubcategories = document.querySelectorAll('.list-subcategories');

  listSubcategories.forEach((section) => {
    const swiperContainer = section.querySelector('.list-subcategories__subcategories');
    const listSubCategoriesCount = Array.from(section.querySelectorAll('.accordion-item')).length;
    const swiperWrapper = section.querySelector('.swiper-wrapper');
    const swiperSlides = section.querySelectorAll('.swiper-slide');
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(swiperContainer, {
      modules: [Pagination, EffectFade, Autoplay],
      loop: false,
      speed: 500,
      slidesPerView: 1,
      effect: 'fade',
      autoHeight: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    swiperContainer.addEventListener('mouseenter', () => {
      swiper.autoplay.stop();
    });


    swiperContainer.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });

    const accordionOuter = section.querySelector('.list-subcategories__wrapper');
    let openAccordionItem = null;

    accordionOuter.addEventListener('mouseup', (event) => {
      if (event?.target?.closest('.accordion-item__label')) {
        toggleAccordion(event);
      }
    });

    accordionOuter.addEventListener('keydown', (event) => {
      if (event?.target?.closest('.accordion-item__label') && event.key === 'Enter') {
        toggleAccordion(event);
      }
    });

    function toggleAccordion(event) {
      const accordionItem = event.target.closest('.accordion-item');
      const header = accordionItem.querySelector('.accordion-item__label');
      const isExpanded = header.getAttribute('aria-expanded') === 'true';

      const updateSwiperSlides = (tabIndex) => {
        if (listSubCategoriesCount === 1) return;

        swiperWrapper.classList.add('fade');

        setTimeout(() => {
          swiperWrapper.classList.remove('fade');
          swiperWrapper.innerHTML = '';

          swiperSlides.forEach((slide) => {
            if (!tabIndex || slide.dataset.loop === String(tabIndex)) {
              swiperWrapper.appendChild(slide);
            }
          });

          if (swiperWrapper.innerHTML.trim() === '') {
            swiperSlides.forEach((slide) => {
              swiperWrapper.appendChild(slide);
            });
          }

          swiper.update();
          swiper.slideTo(0);
        }, 200)
      };

      accordionItem.addEventListener('click', () => {
        const tabIndex = accordionItem.dataset.tab;
        updateSwiperSlides(openAccordionItem ? tabIndex : null);
      });

      if (openAccordionItem && openAccordionItem !== accordionItem) {
        const openHeader = openAccordionItem.querySelector('.accordion-item__label');

        openHeader.setAttribute('aria-expanded', 'false');
        openHeader.classList.remove('accordion-item__label--open');

        const openAdditionalSections = section.querySelectorAll(`.additional-subsection[data-column="${openAccordionItem.dataset.tab}"]`);
        openAdditionalSections.forEach((subsection) => {
          subsection.classList.remove('additional-subsection--open');
        });
      }

      if (!isExpanded) {
        header.setAttribute('aria-expanded', 'true');
        header.classList.add('accordion-item__label--open');
        openAccordionItem = accordionItem;

        const tabIndex = accordionItem.getAttribute('data-tab');
        const additionalSections = section.querySelectorAll(`.additional-subsection[data-column="${tabIndex}"]`);

        additionalSections.forEach((additionalSection) => {
          additionalSection.classList.add('additional-subsection--open');
        });
      } else {
        header.setAttribute('aria-expanded', 'false');
        header.classList.remove('accordion-item__label--open');
        openAccordionItem = null;

        const additionalSections = section.querySelectorAll(`.additional-subsection[data-column="${accordionItem.dataset.tab}"]`);
        additionalSections.forEach((additionalSection) => {
          additionalSection.classList.remove('additional-subsection--open');
        });
      }
    }
  });
});
